import loadable from "@loadable/component";
import { inject } from "mobx-react";
import React from "react";
import { Store } from "../../../../client/stores";
import { RemoteList } from "../../components/remote/RemoteList.component";
import { isFeedBlock, isLeadsCard } from "../../lib/guards";
import { logger } from "../../lib/logging";
import { getPodcastEpisodes } from "../../services/Podcast";
import type { PageBlockInterface } from "../Block.component";

const Cume = loadable(() => import("./Cume.component"));

const log = logger.getChild("Cume Loader");

interface CumeLoaderProps extends PageBlockInterface {
    last_media_id?: string | null;
    store?: Store;
}

export const CumeLoader = inject("store")(({ block, isPrimary, last_media_id, store }: CumeLoaderProps) => {
    if (!store || !block || !block.value) {
        // noop
        return null;
    }
    if (!isFeedBlock(block)) {
        log.error("No Feed on block", block);
        return null;
    }
    if (!block.feed) {
        log.error("No feed on block", block);
        return null;
    }

    if (!block.feed?.results.length) {
        log.debug("No feed results on block: ", block);
        return null;
    }
    const { cache } = store;
    const [{ record: card }] = block.feed.results;

    if (!isLeadsCard(card)) {
        log.error("Not a card", card);
        return null;
    }

    if (!card.catalog || !card.catalog.id) {
        log.error("No catalog id configured in cume card", card);
        return null;
    }
    const { id } = card.catalog;
    const cursor = getPodcastEpisodes({ id: parseInt(id, 10), paging: { take: 1 } }, cache);

    return (
        <RemoteList cursor={cursor} showLoading={isPrimary}>
            {({ data: [episode] }) =>
                episode ? (
                    <Cume
                        title={episode.title}
                        episode_id={"" + episode.id}
                        catalog_id={card.catalog ? card.catalog.id || "" : ""}
                        last_media_id={last_media_id}
                        block={block}
                    />
                ) : null
            }
        </RemoteList>
    );
});
export default CumeLoader;
